import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { Toast, MESSAGE_TYPE } from '@components/Messages';
import LateralSpace from '@components/LateralSpace';
import SpaceLine from '@components/SpaceLine/index';
import LazyList from '@components/LazyList';
import getIdsProducts from '@utils/menu/getIdsProducts';
import WrapSection from './components/WrapSection';
import messages from './messages';

function LayoutOne({
  intl: { formatMessage },
  menu,
  isFetchingMenu,
  onBeforeProductConfig,
  openAgeValidation,
  hasToValidateAge,
  countryCode,
  trackProductSearch,
  getRefs,
  onSectionHeightUpdated,
  sectionsHeights,
}) {
  const sections = menu?.sections || [];
  const hasMenuSections = sections.length > 0;
  const filter = menu?.filter;

  useEffect(() => {
    if (filter) {
      trackProductSearch({
        search: filter,
        succeeded: hasMenuSections,
        idProducts: hasMenuSections ? getIdsProducts(sections) : [],
      });
    }
  }, [trackProductSearch, filter, hasMenuSections, sections]);

  if (!hasMenuSections && filter) {
    return (
      <LateralSpace>
        <SpaceLine value="20px" />
        <Toast
          type={MESSAGE_TYPE.INFO}
          title={formatMessage(messages.menuFilterNoResults, {
            query: filter,
          })}
        />
      </LateralSpace>
    );
  }

  if (!hasMenuSections || isFetchingMenu) return null;

  return (
    <>
      <LazyList
        dataId="id"
        data={menu.sections}
        itemsPerSection={1}
        onSectionHeightUpdated={onSectionHeightUpdated}
        initialSectionsHeights={sectionsHeights}
        getRefs={getRefs}
        isDynamic
      >
        {section => (
          <WrapSection
            section={section}
            countryCode={countryCode}
            hasToValidateAge={hasToValidateAge}
            openAgeValidation={openAgeValidation}
            onBeforeProductConfig={onBeforeProductConfig}
            messageValidateTitle={formatMessage(messages.ageValidata_title)}
            messageValidateSubtitle={formatMessage(
              messages.ageValidata_sub_title,
            )}
          />
        )}
      </LazyList>
    </>
  );
}

LayoutOne.propTypes = {
  // calling component
  menu: PropTypes.object,
  isFetchingMenu: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  onBeforeProductConfig: PropTypes.func.isRequired,
  openAgeValidation: PropTypes.func.isRequired,
  hasToValidateAge: PropTypes.bool.isRequired,
  countryCode: PropTypes.string.isRequired,
  trackProductSearch: PropTypes.func.isRequired,
  getRefs: PropTypes.func,

  // connect
  sectionsHeights: PropTypes.object.isRequired,
  onSectionHeightUpdated: PropTypes.func.isRequired,
};

export default React.memo(injectIntl(LayoutOne));
